module.exports = __webpack_public_path__ + "static/img/fm2.bad7d0a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fm2.jpg
// module id = 2Iob
// module chunks = 1